module.exports = __webpack_public_path__ + "static/media/headphone.dcb76523.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/headphone.jpg
// module id = 1147
// module chunks = 33